
























































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Event } from '@/modules/events/interfaces/event.interface';

const eventStore = namespace('EventStore');

@Component({ name: 'EventModal' })
export default class EventModal extends Vue {
  @eventStore.Action
  createEvent!: (event: Event) => void;
  @eventStore.State
  showEventModal!: boolean;
  @eventStore.Action
  updateEventModalVisibility!: (showEventModal: boolean) => void;
  private event: Event = {
    title: '',
    description: '',
    startDate: new Date(),
    endDate: new Date(),
    maxAttendees: 25,
  };
}
